export default __webpack_public_path__ + "static/media/Decrease-Icon.52a4a31f.svg";